// src/components/GuestOnlyRoute.js

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth'; // (This is your auth context or hook)

/**
 * If the user IS logged in, redirect them away from guest pages
 * (like login, register) to the main app page.
 * * If they are NOT logged in, show the child route (Outlet).
 */
function GuestOnlyRoute({ redirectTo = '/tasks' }) {
  const { user } = useAuth(); // Or however you check for a logged-in user

  // If user exists (is logged in), redirect
  if (user) {
    return <Navigate to={redirectTo} replace />;
  }

  // If no user (is a guest), show the child component (Login, Register, etc.)
  return <Outlet />;
}

export default GuestOnlyRoute;
